import { render, staticRenderFns } from "./DsnFoldablePanel.vue?vue&type=template&id=57a9d828&"
import script from "./DsnFoldablePanel.vue?vue&type=script&lang=js&"
export * from "./DsnFoldablePanel.vue?vue&type=script&lang=js&"
import style0 from "./DsnFoldablePanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports